export enum OriginIndividual {
    Immigrant = 1,
    F1 = 2,
    Hybrid= 3,
    F2 = 4,
    Finsk = 5
}
